import { Component, OnInit, OnDestroy } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SidenavService } from "src/app/layout/sidenav/sidenav.service";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { ApiService } from "src/app/services/api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { ErrorType } from "src/app/enums/error-type.enum";
import endpoints from "src/app/helpers/endpoints";
import { StorageService } from "src/app/services/storage.service";
import { EventService } from "src/app/services/event.service";

@Component({
  selector: "fury-claim-status",
  templateUrl: "./claim-status.component.html",
  styleUrls: ["./claim-status.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class ClaimStatusComponent implements OnInit, OnDestroy {
  selectConfig = { disableOptionCentering: true, panelClass: "custom-class" };
  claimStatusForm = new FormGroup({
    status: new FormControl<string | null>("", [Validators.required]),
    note: new FormControl<string | null>("", [Validators.required]),
  });

  ngUnSubscribe = new Subject<void>();
  claimStatus: any[] = [];
  displayedColumns: string[] = [
    "createdAt",
    "updatedAt",
    "changedBy",
    "status",
    "note",
  ];
  pageIndex = 0;
  pageSize = 30;
  totalCount = 0;
  dataSource = [];
  claimId = "";
  agentId = "";
  userId = "";
  claimDetails: any;

  constructor(
    private sidenavService: SidenavService,
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private storageService: StorageService,
    private router: Router,
    private eventService: EventService
  ) {}

  ngOnInit(): void {
    this.claimId = this.activatedRoute.snapshot.params["claimId"];
    this.userId = this.activatedRoute.snapshot.params["id"];
    if (this.claimId) {
      this.getClaimStatusHistory();
      this.getClaimDetails();
    }
    setTimeout(() => {
      this.sidenavService.close();
    }, 0);
    this.agentId = this.storageService.getUser()?.userId;
    this.eventService.getClaimStatus$
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe((status: any[]) => {
        this.claimStatus = status;
      });
  }
  getClaimDetails() {
    this.apiService
      .get(endpoints.customerDashboard.getClaimDetails(this.claimId))
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            this.claimDetails = res.body?.claim;
            this.claimStatusForm.patchValue({
              status: res.body?.claim?.status,
            });
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }
  changeStatus() {
    if (this.claimStatusForm.valid) {
      const payload: any = this.claimStatusForm.value;
      payload.agentId = this.agentId;
      this.apiService
        .patch(
          endpoints.customerDashboard.changeClaimStatus(this.claimId),
          payload
        )
        .pipe(takeUntil(this.ngUnSubscribe))
        .subscribe({
          next: (res: HttpResponse<any>) => {
            if (res) {
              this.apiService.alert(res.body.message, ErrorType.Success);
              this.getClaimStatusHistory();
            }
          },
          error: (err: HttpErrorResponse) => {
            this.apiService.alert(err.message, ErrorType.Error);
          },
        });
    } else {
      this.claimStatusForm.markAllAsTouched();
    }
  }
  getClaimStatusHistory() {
    this.apiService
      .get(
        `admin/claim/file-claim/get-status-history/${this.claimId}?page=${
          this.pageIndex + 1
        }&size=${this.pageSize}`
      )
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            this.dataSource = res.body?.fileClaims?.data;
            this.totalCount = res.body?.fileClaims?.total;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }
  pageSizeChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.getClaimStatusHistory();
  }
  redirectToDashboard() {
    this.router.navigateByUrl(`customer-dashboard/${this.userId}`);
  }
  ngOnDestroy(): void {
    this.ngUnSubscribe.next();
    this.ngUnSubscribe.complete();
  }
}
